import { WebRTCClient } from "@infrastructure/clients/webrtc/clients/base/webrtc.client";
import { RestClient } from "@infrastructure/clients/http/clients/base/rest.client";
import { BASE_URL } from "@infrastructure/clients/http/config";

export class VideoWebRTCClient extends WebRTCClient {
  private signalingClient: RestClient;

  constructor() {
    super();
    this.signalingClient = new (class extends RestClient {
      baseUrl = BASE_URL;
    })();
  }

  async exchangeSignaling(offer: RTCSessionDescriptionInit): Promise<RTCSessionDescriptionInit> {
    // Используем axios напрямую для signaling
    const axios = await import("axios");
    const response = await axios.default.post(
      `${BASE_URL}/api/webrtc/signaling`,
      { offer },
      {
        headers: {
          Authorization: `Bearer ${(await import("@infrastructure/clients/http/authToken")).authToken.get()}`,
        },
      }
    );
    return response.data.data.answer;
  }

  async startCall(remoteUserId: string): Promise<RTCSessionDescriptionInit> {
    const connection = await this.createConnection({
      onConnectionStateChange: (state) => {
        console.log("[WebRTC] Connection state:", state);
      },
    });

    const offer = await this.createOffer();
    
    // Отправляем offer через signaling server
    const answer = await this.exchangeSignaling(offer);
    await this.setRemoteDescription(answer);

    return offer;
  }

  async receiveCall(offer: RTCSessionDescriptionInit): Promise<RTCSessionDescriptionInit> {
    await this.createConnection({
      onConnectionStateChange: (state) => {
        console.log("[WebRTC] Connection state:", state);
      },
    });

    await this.setRemoteDescription(offer);
    const answer = await this.createAnswer(offer);
    
    return answer;
  }
}

